import React from 'react';
import {IconArrowBottom} from '../../../system/icons/IconArrowBottom';
import {IconArrowUp} from '../../../system/icons/IconArrowUp';
import {SkeletonLoader} from '../../../system/SkeletonLoader/SkeletonLoader';
import css from './ReportsV2StatisticsItem.module.scss';
import classNames from 'classnames';

type StatisticsItemProps = {
  value?: number | string | React.ReactElement;
  percantage?: number;
  loading?: boolean;
  valueSubText?: string;
  title: string;
  titleIcon?: React.ReactElement;

  listView?: boolean;
};

export const StatisticsItem = ({
  value,
  percantage,
  loading,
  valueSubText,
  title,
  titleIcon,
  listView,
}: StatisticsItemProps) => {
  const emptyValuePlaceholder = loading ? '--' : '0';
  const icon =
    percantage && percantage > 0 ? (
      <IconArrowUp className={css.statisticsItemPercantageIcon} />
    ) : (
      <IconArrowBottom className={css.statisticsItemPercantageIcon} />
    );

  const valueText =
    typeof value === 'number'
      ? value.toLocaleString('en-US', {maximumFractionDigits: 2})
      : value;

  return (
    <div
      className={classNames(css.statisticsItem, {
        [css.listView]: listView,
      })}
    >
      <div className={css.statisticsItemDescription}>
        {titleIcon
          ? React.cloneElement(titleIcon, {
              className: classNames(
                titleIcon?.props?.className,
                css.statisticsItemTitleIcon
              ),
            })
          : null}
        {title}
      </div>
      <div className={css.statisticsItemMainRow}>
        {loading ? (
          <SkeletonLoader type="text" widthFromTo={[30, 100]} />
        ) : (
          <div className={css.statisticsItemValue}>
            {valueText || emptyValuePlaceholder}
            {valueSubText && !loading && (
              <span className={css.statisticsItemValueDef}>{valueSubText}</span>
            )}
          </div>
        )}

        {!loading && percantage ? (
          <div className={css.statisticsItemPercantage}>
            {icon}
            {percantage ? `${Math.abs(percantage)}%` : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};
